import { Autocomplete, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

import useDebouncedState from "~/shared/hooks/useDebouncedState";

import useSpeciesSelect_GetAutocompleteOptions from "./api/useSpeciesSelect_GetAutocompleteOptions";
import { SpeciesSelectSingleProps } from "./types";

export default function SpeciesSelectSingle({
    value,
    onChange,
    disabled,
    label,
    excludeAssignedToResearchTypeId,
    error,
    helperText,
}: SpeciesSelectSingleProps) {
    const { t } = useTranslation("shared");

    const [searchQuery, debouncedSearchQuery, setSearchQuery] = useDebouncedState("");

    const { options, selectedOptions, loading } = useSpeciesSelect_GetAutocompleteOptions({
        q: debouncedSearchQuery || undefined,
        excludeAssignedToResearchTypeId,
        selectedIds: value ? [value] : undefined,
    });

    const singleSelectValue = selectedOptions.find(x => x.value === value) ?? null;

    return (
        <Autocomplete
            noOptionsText={
                searchQuery.length === 0 ? t("SpeciesSelect.typeToSearchLabel") : t("SpeciesSelect.noOptionsFoundLabel")
            }
            disabled={disabled}
            disableClearable={singleSelectValue !== null}
            filterOptions={x => x}
            getOptionLabel={option => option.label}
            getOptionKey={option => option.value}
            loading={loading}
            inputValue={searchQuery}
            onInputChange={(_, newInputValue, reason) => {
                if (reason === "reset") return;
                setSearchQuery(newInputValue);
            }}
            options={options}
            value={singleSelectValue}
            onChange={(_, nextValue) => {
                if (nextValue) {
                    onChange(nextValue.value);
                }
            }}
            renderInput={params => (
                <TextField {...params} label={label} error={error} helperText={helperText} variant="outlined" />
            )}
        />
    );
}
